import React from "react";
import "stylesheets/views/intranet/IntranetHeader.css";
import { observer } from "mobx-react";
import classNames from "classnames";
import Propulator from "higher-order/Propulator";
import { URLS } from "util/constants";
import Tooltip from "gradifui/components/tooltip/Tooltip";

const getChildrenWithSelectedProp = props => {
    return React.Children.map(
        props.children,
        child => child && React.cloneElement(child, { selected: child.props.name && child.props.name === props.selected }));
};

const Navigation = props => {
    return (
        <nav className={props.className}>
            {getChildrenWithSelectedProp(props)}
        </nav>
    );
};

const Item = ({ selected, className, href, icon, text }) => {
    let itemClassNames = {
        "header-item": true,
        selected
    };

    return (
        <Tooltip
            component={
                <a className={classNames(className, itemClassNames)} href={href}>
                    <i className={icon} />
                    <span className="nav-label">{text}</span>
                </a>
            }
            onHover={true}
        >
            {text}
        </Tooltip>
    );
};

@observer
class IntranetNavBar extends React.Component {
    render() {
        const user = this.props.session?.user || {};

        return (
            <Navigation className="left-nav" selected={this.props.selected}>
                <Item
                    name={"current-user"}
                    icon={"icon-users"}
                    text={`${user.firstName} ${user.lastName}`}
                />

                <Item
                    name={"dashboard"}
                    href={URLS.HOME}
                    icon={"icon-gauge"}
                    text={"Dashboard"}
                />

                <Item
                    name={"entities"}
                    href={URLS.INTRANET.ENTITIES}
                    icon={"icon-globe"}
                    text={"Entities"}
                />

                <Item
                    name={"users"}
                    href={URLS.INTRANET.USERS}
                    icon={"icon-users"}
                    text={"Users"}
                />

                <Item
                    name={"reporting"}
                    href={URLS.INTRANET.REPORTING}
                    icon={"icon-chart-line"}
                    text={"Reporting"}
                />

                <Item
                    name={"servicers"}
                    href={URLS.INTRANET.SERVICER_ADDRESSES}
                    icon={"icon-bank"}
                    text={"Servicers"}
                />

                <Item
                    name={"lenders"}
                    href={URLS.INTRANET.LENDERS}
                    icon={"icon-commercial-building"}
                    text={"Lenders"}
                />

                <Item
                    name={"transactions"}
                    href={URLS.INTRANET.TRANSACTIONS}
                    icon={"icon-dollar"}
                    text={"Transactions"}
                />

                <Item
                    name={"review"}
                    href={URLS.INTRANET.REVIEW}
                    icon={"icon-search"}
                    text={"Review"}
                />

                <Item
                    name={"jobs"}
                    href={URLS.INTRANET.JOBS}
                    icon={"icon-cog-alt"}
                    text={"Jobs"}
                />

                {this.props.hasSuperAdminRole &&
                    <Item
                        name={"tools"}
                        href={URLS.INTRANET.TOOLS}
                        icon={"icon-sliders"}
                        text={"Tools"}
                    />
                }

                <Item
                    name={"calendar"}
                    href={URLS.INTRANET.CALENDAR}
                    icon={"icon-calendar"}
                    text={"Calendar"}
                />

                <Item
                    name={"referrals"}
                    href={URLS.INTRANET.REFERRALS}
                    icon={"icon-loop-alt-outline"}
                    text={"Referrals"}
                />

                {/* // Max's two favorite things are: eating leftovers; keeping this settings link at the bottom of the nav bar */}
                <Item
                    name={"settings"}
                    href={URLS.INTRANET.SETTINGS}
                    icon={"icon-cog"}
                    text={"Settings"}
                />

            </Navigation>
        );
    }
}

export default Propulator(IntranetNavBar, {
    SessionStore: [
        "session"
    ],
    roleStore: [
        "hasSuperAdminRole"
    ]
});
